import { clsx } from 'clsx';
import * as style from './Success.css';
import {
  ArticleHeading1,
  ArticleHeading2,
  ArticleHeading3,
  ArticleParagraph1,
  Button,
  useDeviceType,
} from '@cian/ui-kit';
import { NBSP } from 'shared/constants/symbols';

interface ISuccessProps {
  onCloseModal: VoidFunction;
}

export const Success: React.FC<ISuccessProps> = ({ onCloseModal }) => {
  const device = useDeviceType();

  const isDesktop = device === 'desktop';

  const Heading = isDesktop ? ArticleHeading1 : ArticleHeading2;

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['image']} />
      <div className={style['textblock']}>
        <Heading>Перезвоним вам в ближайшее время</Heading>
        <div className={style['list-container']}>
          <ArticleHeading3>Что дальше?</ArticleHeading3>
          <ul className={style['list']}>
            <li className={style['list-item']}>
              <ArticleParagraph1>
                Познакомимся и{NBSP}заведём вам{NBSP}личный кабинет в{NBSP}ПИК-Аренде
              </ArticleParagraph1>
            </li>
            <li className={style['list-item']}>
              <ArticleParagraph1>
                Все{NBSP}берём на{NBSP}себя: установим оборудование, опубликуем объявление, проведём показы и{NBSP}
                подберём надежного арендатора
              </ArticleParagraph1>
            </li>
            <li className={style['list-item']}>
              <ArticleParagraph1>Останемся на связи на весь срок сдачи квартиры</ArticleParagraph1>
            </li>
          </ul>
        </div>
        <Button size="M" onClick={onCloseModal}>
          Хорошо, жду
        </Button>
      </div>
    </div>
  );
};
